/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CoaAccountCategory } from './CoaAccountCategory';
/**
 * The chart-of-accounts match assigned to a parsed line item by the AI parser
 * or by a user manual override.
 *
 * Shared by operating statement line items and rent roll charge codes.
 *
 * `confidence: 'user'` means the match was set manually.
 */
export type ParsedLineItemCoaMatch = {
    id: number;
    name: string | null;
    category: CoaAccountCategory;
    confidence: ParsedLineItemCoaMatch.confidence;
};
export namespace ParsedLineItemCoaMatch {
    export enum confidence {
        HIGH = 'high',
        MEDIUM = 'medium',
        LOW = 'low',
        USER = 'user',
    }
}

